import { FormikErrors } from 'formik';

/**
 * Formats API error codes like "err-aggregate-limit-duplicate-record-for-customer"
 * into human-readable text: "Aggregate limit duplicate record for customer"
 */
export const formatApiError = (message: string | null | undefined): string => {
  if (!message) return '';
  return message
    .replace(/^err-/, '')
    .replace(/-/g, ' ')
    .replace(/^\w/, (c) => c.toUpperCase());
};

/**
 * Safely converts Formik errors to string for display in React children
 * Handles string, string[], FormikErrors, and FormikErrors[] types
 */
export const getFormikErrorAsString = (error: string | string[] | FormikErrors<any> | FormikErrors<any>[] | undefined): string => {
    if (error === undefined || error === null) {
        return '';
    }
    
    if (typeof error === 'string') {
        return error;
    }
    
    if (Array.isArray(error)) {
        // If it's an array of strings, join them
        if (error.length > 0 && typeof error[0] === 'string') {
            return error.join(', ');
        }
        // If it's an array of FormikErrors, convert first one to string
        if (error.length > 0) {
            return String(error[0] || '');
        }
        return '';
    }
    
    // If it's a FormikErrors object, convert to string
    return String(error || '');
};

/** Prefix +91 when the user entered a 10-digit Indian mobile without a country code. */
export function normalizeIndianMobileForApi(value: string): string {
  const trimmed = (value || "").trim();
  const digits = trimmed.replace(/\D/g, "");
  if (/^[6-9]\d{9}$/.test(digits)) {
    return `+91${digits}`;
  }
  return trimmed;
}
